import {
  Paper,
  Typography,
} from "@mui/material";

// ----------------------------------------------------------------------

export default function NoTrackingRecord() {
  return (
    <Paper
      sx={{ alignItems: 'center', textAlign: 'center', py: 6 }}
    >
      <Typography variant="h6" paragraph>
        아직 기록된 근무가 없어요.
      </Typography>
      <Typography variant="body2" color="text.disabled">
        아직 근무 기록이 없어요. <br />
        출근하기를 눌러서 회사에 알려주세요!
      </Typography>
    </Paper>
  )
}